module.exports = __webpack_public_path__ + "static/media/logo.6ac94932.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 676
// module chunks = 0